import React, { useEffect, useRef } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';

import Stack from 'components/shared/Stack';

import { RootState } from 'state/store';
import { selectLeadCommunications, selectLeadFullName } from 'state/lead.state';
import { formatDate } from 'utils/functions';

import LeadCreation from './LeadCreation';
import Communication from './Communication';
import { LoadingStates } from 'typings';

const LeadCommunications = styled('div')`
  padding: ${(props) => props.theme.spacing(1)};
`;

const Messages = () => {
  const lead = useSelector(
    (state: RootState) => ({
      channelWebsite: state.lead.entity?.channelWebsite,
      createdAt: state.lead.entity?.createdAt,
      emailContentLink: state.lead.entity?.emailContentLink,
      timezone: state.lead.entity?.timezone,
    }),
    shallowEqual
  );
  const leadName = useSelector(selectLeadFullName);
  const leadCommunications = useSelector(selectLeadCommunications);
  const loadedLeadCommunications = leadCommunications.filter(
    ({ loadingState }) => loadingState !== LoadingStates.LOADING
  );

  const divRef: any = useRef();
  const theme = useTheme();
  const isConciergeAdmin = useSelector((state: RootState) => !!state.concierge.entity?.isAdmin);

  // scroll to most recent messages
  useEffect(() => {
    divRef.current.scrollIntoView({ behavior: 'auto' });
  }, [loadedLeadCommunications.length]);

  const communications = loadedLeadCommunications.map((communication) => (
    <Communication
      key={`${communication.commType}:${communication.id}`}
      type={communication.commType}
      isConciergeAdmin={isConciergeAdmin}
      communication={{
        ...communication,
        leadName: leadName,
        leadTimezone: lead.timezone,
        createdAt: formatDate(communication.createdAt, 'MMMM D, YYYY h:mm:ss A'),
      }}
      isAdminAction={isConciergeAdmin}
      isCensored={!!communication.hasIssue}
    />
  ));

  return (
    <>
      <LeadCommunications>
        <Stack space={theme.spacing(1.5)}>
          <LeadCreation lead={lead} />
          {communications}
        </Stack>
      </LeadCommunications>
      <div ref={divRef} />
    </>
  );
};

export default Messages;
